import './new-tenant.scss';

import { FormProvider } from "react-hook-form";
import { FaChevronLeft } from "react-icons/fa6";
import { Button } from "primereact/button";

import HeaderContent from "@shared/ui/header-content/header-content";
import FormTenant from "../form-tenant/form-tenant";
import { useNewTenant } from './new-tenant.hook';

export function NewTenant() {  
  const {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  } = useNewTenant();

  return (
    <div id="NewTenant" className="tenant">
      <HeaderContent
        title="New Tenant"
        backIcon={<FaChevronLeft />}
        onBack={() => navigate("../")}
      >
        <Button
          className="w-full block"
          label="Save"
          disabled={isCreating}
          onClick={handleSubmit(handleValidate, handleValidateError)}
        ></Button>
      </HeaderContent>

      <div className="p-7">
        <FormProvider {...formMethod}>
          <section className="grid grid-cols-1 md:grid-cols-2 gap-2 mb-4">
            <FormTenant />
          </section>
        </FormProvider>
      </div>
    </div>
  );
}

export default NewTenant;